/**
 * UK mobile numbers once spaces are removed: 07 followed by 9 digits,
 * or the international forms +447 / 447 followed by 9 digits.
 */
const UK_MOBILE_PATTERN = /^(?:07\d{9}|\+447\d{9}|447\d{9})$/;

const WHITESPACE = /\s/g;

/**
 * Returns true when the value is a UK mobile number, e.g. "07700 900123", "+447700900123" or "44 7700 900123".
 */
export const checkPhoneNumber = (value: unknown): boolean => {
    if (typeof value !== 'string') {
        return false;
    }

    return UK_MOBILE_PATTERN.test(value.replace(WHITESPACE, ''));
};
